(function() {
    window.addEventListener('load', function() {
        var eyes = document.getElementsByClassName("eye");

        if(eyes.length > 0) {
            document.onmousemove = function(){
                var x = event.clientX * 100 / window.innerWidth + "%";
                var y = event.clientY * 100 / window.innerHeight + "%";

                for(var i=0;i<2;i++){
                    eyes[i].style.left = x;
                    eyes[i].style.top = y;
                    eyes[i].style.transform = "translate(-"+x+",-"+y+")";
                }
            }
        }
    })
})();


//////////////////
// WEBPACK FOOTER
// ./js/404.js
// module id = 4
// module chunks = 0